export default "__VITE_ASSET__bDXJ5GoM__"